import { Button } from "@mui/material";
// import "../styles/components/custom-button.scss";

interface Props {
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  variant?: "text" | "outlined" | "contained" | undefined;
  style?: React.CSSProperties | undefined;
  className?: string | undefined;
  displayText: string | undefined;
}

function joinAllClasses(...classes: any[]) {
  return classes.join(" ");
}

const CustomButton = ({
  onClick,
  variant,
  style,
  className,
  displayText,
}: Props) => {
  const defaultStyle = {};
  return (
    <>
      <Button
        onClick={onClick}
        variant={variant ? variant : "text"}
        style={style ? style : defaultStyle}
        className={className}
      >
        {displayText}
      </Button>
    </>
  );
};

export default CustomButton;
